import pick from 'lodash.pick';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Collapse, FormFeedback, FormGroup, Row } from "reactstrap";
import { Field, Fields, reduxForm } from 'redux-form';
import { normalizePhone } from "../../../../../util/normalizers";
import { AddressInputField, DateField, InputField } from "../../../../../validation/ReduxFormInput";
import { handleAddRentalHistory } from "../../../actions/application";



class AddRentalHistoryForm extends Component {
    state = {
        addressSelected: false,
    };

    onPlaceIdSelect = (place_id) => {
        place_id && this.setState({addressSelected: true});
    };

    render() {

        const {handleSubmit} = this.props;
        return (
            <div className="mb-5">
                <form onSubmit={handleSubmit}>
                    <FormGroup color={this.state.addressSelected ? 'success' : 'default'}>
                        <Fields
                            names={["place_id", "formatted_address", "identifier"]}
                            ref={node => this.address = node}
                            label="Address:"
                            component={AddressInputField}
                            onPlaceIdSelect={this.onPlaceIdSelect}
                            withRef
                        />
                        {this.state.addressSelected && <FormFeedback>Got it!</FormFeedback>}
                    </FormGroup>
                    <Collapse isOpen={this.state.addressSelected}>
                        <Row>
                            <Col xs={12} sm={4}><Field name="rent_amount" label="Monthly rent" addon="$" min={0} step={1} component={InputField} type="number"/></Col>
                            <Col xs={12} sm={4}>
                                <Field name="lease_start"
                                       label="Lease Start Date"
                                       component={DateField}/>
                            </Col>
                            <Col xs={12} sm={4}>
                                <Field name="lease_end"
                                       label="Lease End Date"
                                       component={DateField}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="leave_reason" label="Tell us why you left/why you're leaving:"
                                       placeholder="'We needed a bigger place', 'Rent was too high', 'I wanted to live off campus', etc. Put 'N/A' if you haven't left yet." component={InputField}
                                       type="textarea"/>
                            </Col>
                        </Row>
                        <h5>Landlord Information</h5>
                        <div className="mb-2" style={{marginTop: '-0.5rem', paddingLeft: '0'}}>
                            <p>Why do we need this? Good question! Your future landlords want to figure out what kind of tenant you were; the best way for them to do that is to ask someone that has
                                rented to you in the past. We'll be reaching out to them too, so make sure this information is correct.</p>
                        </div>

                        <Row>
                            <Col xs={12} sm={4}><Field name="name" label="Landlord Name" component={InputField}/></Col>
                            <Col xs={12} sm={4}><Field name="phone" label="Landlord Phone" component={InputField} normalize={normalizePhone} placeholder="555-555-5555"/></Col>
                            <Col xs={12} sm={4}><Field name="email" label="Landlord email" component={InputField} type="email"/></Col>
                        </Row>
                        <div className="center">
                            <small className="text-info">By filling out this form, you're authorizing us to reach out to your landlord for a rental reference.</small>
                        </div>
                    </Collapse>
                </form>
            </div>
        );
    }
}

const validate = (values) => {
    const errors = {};

    !values.name && (errors.name = 'Required');
    !values.rent_amount && (errors.rent_amount = 'Required');
    !values.lease_start && (errors.lease_start = 'Required');
    !values.lease_end && (errors.lease_end = 'Required');
    !values.leave_reason && (errors.leave_reason = 'Required');
    !values.email && (errors.email = 'Required');
    !values.phone && (errors.phone = 'Required');
    (values.phone && values.phone.length !== 12) && (errors.phone = 'Please enter a valid phone number');

    if (values.lease_end && values.lease_start) {
        moment(values.lease_end).isBefore(values.lease_start) && (errors.lease_end = 'Must be after lease start date!');
    }

    return errors;
};

const submit = (data, dispatch, props) => {
    const history = Object.assign({}, pick(data, [
        'place_id',
        'identifier',
        'rent_amount',
        'lease_start',
        'lease_end',
        'leave_reason'
    ]));
    const reference = Object.assign({}, pick(data, [
        'name',
        'email',
        'phone',
    ]));


    return dispatch(handleAddRentalHistory(history, reference)).then(() => props.onAdd());
};

AddRentalHistoryForm = reduxForm({
    form: 'application_rental_history',
    onSubmit: submit,
    validate
})(AddRentalHistoryForm);

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(AddRentalHistoryForm);



// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/forms/AddRentalHistoryForm.js